var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldSmsSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 3C4 3 2 4.5 2 8v7.96c0 2.29 1.85 4.14 4.14 4.14h6.26c.58 0 1.08-.49 1.02-1.07-.14-1.53.36-3.18 1.72-4.51.56-.55 1.25-.97 2-1.21 1.25-.4 2.46-.35 3.53.02a1 1 0 0 0 1.33-.94V8c0-3.5-2-5-5-5H7zm7.34 8.09c-.66.53-1.5.79-2.34.79-.84 0-1.69-.26-2.34-.79l-3.13-2.5a.768.768 0 0 1-.12-1.06c.26-.32.73-.38 1.05-.12l3.13 2.5c.76.61 2.05.61 2.81 0l3.13-2.5c.32-.26.8-.21 1.05.12.26.33.21.8-.11 1.06l-3.13 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9 20.699a3.756 3.756 0 0 0-3.14-5.82c-2.08 0-3.76 1.68-3.76 3.75 0 2.07 1.68 3.76 3.76 3.76.76 0 1.47-.23 2.06-.62l.75.75c.15.15.34.22.54.22s.39-.07.54-.22c.3-.29.3-.77 0-1.07l-.75-.75z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldSmsSearch);
export default __webpack_public_path__ + "static/media/vuesax-bold-sms-search.f0849aeba60cd0fe256d19f91308f8df.svg";
export { ForwardRef as ReactComponent };